import React from 'react';
import Banner from '../components/Banner';
import Content from '../components/Content';
import Overview from '../components/Overview';

const Home: React.FC = () => {
  return (
    <div className="templates-wrapper">
      <Banner />
      <Content />
      <Overview />
    </div>
  );
};

export default Home;